import { Prop, Vue } from 'vue-property-decorator';
import { ShoppingCartItemDto, ShoppingCartItemGroupDto } from '@/api';
import { ProductTuple } from '@/stores/search/util';

export class AbstractGroupWidget extends Vue {
  @Prop({required: true})
  public itemGroup!: ShoppingCartItemGroupDto;

  get cartGroupItems(): ShoppingCartItemDto[] {
    return this.itemGroup.items;
  }

  get cartGroupLabel() {
    if (this.itemGroup.category && this.itemGroup.category.name) {
      return this.itemGroup.category.name;
    }
    return this.$t('message.cart.otherCategory');
  }

  public constructProductTuple(shoppingCartItem: ShoppingCartItemDto): ProductTuple {
    return {
      product: shoppingCartItem.product!,
      unit: shoppingCartItem.unit!,
    };
  }
}
